import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Mail, Linkedin, Github, ArrowRight } from 'lucide-react';
import { personalInfo } from '../../data/mock';
import ContactModal from './ContactModal';

const contacts = [
  {
    icon: Mail,
    label: 'Email',
    value: personalInfo.email,
    href: `mailto:${personalInfo.email}`,
    color: '#00D4FF',
  },
  {
    icon: Linkedin,
    label: 'LinkedIn',
    value: personalInfo.linkedin,
    href: personalInfo.linkedinUrl,
    color: '#0A66C2',
  },
  {
    icon: Github,
    label: 'GitHub',
    value: personalInfo.github,
    href: personalInfo.githubUrl,
    color: '#F0F4FF',
  },
];

const ContactSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section id="contact" className="py-24 relative z-10">
      <div className="container mx-auto px-6 lg:px-16">
        <motion.span
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="section-label block mb-4"
        >
          // LET'S BUILD
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="font-display text-3xl lg:text-5xl font-bold text-[#F0F4FF] mb-8 leading-tight"
        >
          Got a hard AI problem?<br />Let's solve it.
        </motion.h2>

        {/* Contact cards */}
        <div className="grid sm:grid-cols-3 gap-6 mb-12 max-w-3xl">
          {contacts.map((contact, index) => (
            <motion.a
              key={index}
              href={contact.href}
              target="_blank"
              rel="noopener noreferrer"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.12 }}
              className="glass-card glass-card-hover rounded-xl p-5 group block"
            >
              <contact.icon
                size={24}
                style={{ color: contact.color }}
                className="mb-3 group-hover:scale-110 transition-transform duration-300"
              />
              <p className="font-mono text-xs text-[#8892A4] mb-1">{contact.label}</p>
              <p className="font-mono text-sm text-[#F0F4FF] break-all">{contact.value}</p>
            </motion.a>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ delay: 0.4 }}
        >
          <button
            onClick={() => setIsModalOpen(true)}
            className="inline-flex items-center gap-2 px-8 py-4 rounded-lg bg-[#00D4FF] text-[#080C14] font-display font-bold text-lg hover:bg-[rgba(0,212,255,0.85)] transition-colors duration-300 group"
          >
            Send Me a Message
            <ArrowRight
              size={20}
              className="group-hover:translate-x-1 transition-transform duration-300"
            />
          </button>

          <p className="font-mono text-sm text-[#8892A4] mt-6">
            Open to:{' '}
            <span className="text-[#00D4FF]">AI Engineer</span> &middot;{' '}
            <span className="text-[#39FF14]">AI Agent Engineer</span> &middot;{' '}
            <span className="text-[#F5A623]">Founding AI Engineer</span>
          </p>
        </motion.div>
      </div>
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </section>
  );
};

export default ContactSection;
